export default __webpack_public_path__ + "static/media/Facebook.85852903.svg";